/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Alias_WhatsAppMessageCreateBodyParams } from '../models/Alias_WhatsAppMessageCreateBodyParams';
import type { V2WhatsAppMessageCreateBodyParams } from '../models/V2WhatsAppMessageCreateBodyParams';
import type { WhatsAppMediaUploadBodyParams } from '../models/WhatsAppMediaUploadBodyParams';
import type { WhatsAppMediaUploadResponse } from '../models/WhatsAppMediaUploadResponse';
import type { WhatsAppMessageCreateResponse } from '../models/WhatsAppMessageCreateResponse';
import type { WhatsAppTemplateMessageCreateBodyParams } from '../models/WhatsAppTemplateMessageCreateBodyParams';
import type { WhatsAppTemplateMessageCreateResponse } from '../models/WhatsAppTemplateMessageCreateResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MessagingWhatsappMessagesService {
    /**
     * @deprecated
     * @param conversationId
     * @param requestBody
     * @returns WhatsAppMessageCreateResponse Ok
     * @throws ApiError
     */
    public static v1CreateMessage(
        conversationId: string,
        requestBody: Alias_WhatsAppMessageCreateBodyParams,
    ): CancelablePromise<WhatsAppMessageCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/messaging/whatsapp/messages/conversations/{conversationId}',
            path: {
                'conversationId': conversationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden.`,
            },
        });
    }
    /**
     * Send a WhatsApp template message.
     *
     * **Note:** You must use either 'variables' OR 'components', but not both:
     * - Use 'variables' for simple cases with only text variables in the body component
     * - Use 'components' for full functionality including images, documents, currency, headers, and buttons
     *
     * **Important:** While the API supports all WhatsApp template components, templates with some components
     * (like images, documents, currency) are not yet supported using the LlamadaPro UI.
     *
     * Phone numbers must be in E.164 format (e.g. +14155552671)
     * @param requestBody
     * @returns WhatsAppTemplateMessageCreateResponse Ok
     * @throws ApiError
     */
    public static createTemplateMessage(
        requestBody: WhatsAppTemplateMessageCreateBodyParams,
    ): CancelablePromise<WhatsAppTemplateMessageCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/messaging/whatsapp/messages/templates',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden.`,
            },
        });
    }
    /**
     * Send a WhatsApp free form message.
     *
     * Supports sending various types of messages including text, images, documents, etc.
     * For media messages, provide a fileId from the files service.
     *
     * Phone numbers must be in E.164 format (e.g. +14155552671)
     * @param requestBody
     * @returns WhatsAppMessageCreateResponse Ok
     * @throws ApiError
     */
    public static createMessage(
        requestBody: V2WhatsAppMessageCreateBodyParams,
    ): CancelablePromise<WhatsAppMessageCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/messaging/whatsapp/messages',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden.`,
            },
        });
    }
    /**
     * Upload media to WhatsApp Business API.
     *
     * Supports two modes:
     * 1. File ID mode: Upload existing file from files service via `fileId`
     * 2. Direct upload mode: Upload raw file data via `fileName`, `contentType`, and `content`
     *
     * Phone numbers must be in E.164 format (e.g. +14155552671)
     * @param requestBody
     * @returns WhatsAppMediaUploadResponse Ok
     * @throws ApiError
     */
    public static uploadMedia(
        requestBody: WhatsAppMediaUploadBodyParams,
    ): CancelablePromise<WhatsAppMediaUploadResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/messaging/whatsapp/messages/media',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden.`,
            },
        });
    }
}
